export interface CategoryInfo {
  slug: string;
  name: string;
  title: string;
  description: string;
}

export const BLOG_CATEGORIES_LIST: CategoryInfo[] = [
  {
    slug: "pricing-reviews",
    name: "Pricing & Reviews",
    title: "Pricing & Reviews",
    description:
      "Detailed pricing reviews, cost analyses, and ROI calculators for conversational voice AI solutions.",
  },
  {
    slug: "company-updates",
    name: "Company Updates",
    title: "Company Updates",
    description:
      "Read company announcements, product releases, fundraising milestones, and updates from the team.",
  },
  {
    slug: "voice-ai-guides",
    name: "Voice AI Guides",
    title: "Voice AI Guides",
    description:
      "Comprehensive engineering guides, SIP architecture, and deployment strategies for enterprise voice AI.",
  },
  {
    slug: "tool-comparisons",
    name: "Tool Comparisons",
    title: "Tool Comparisons",
    description:
      "In-depth evaluations, feature comparisons, and pricing breakdowns of leading voice AI platforms and alternatives.",
  },
  {
    slug: "ai-use-cases",
    name: "AI Use Cases",
    title: "AI Use Cases",
    description:
      "Explore practical AI use cases for sales, support, call centers, ecommerce, and customer operations, with guides on using voice AI to automate workflows.",
  },
];
